export default __webpack_public_path__ + "static/media/closet5-after2-1440w.dc787ca2.webp";